
import React, { Suspense, lazy } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const TradingViewWidget = lazy(() => import('./TradingViewWidget'));

interface LazyTradingViewWidgetProps {
  symbol?: string;
  type?: 'chart' | 'news';
}

const LazyTradingViewWidget = ({ symbol, type }: LazyTradingViewWidgetProps) => {
  return (
    <Suspense fallback={<Skeleton className="w-full h-[300px]" />}>
      <TradingViewWidget symbol={symbol} type={type} />
    </Suspense>
  );
};

export default LazyTradingViewWidget;
